import { LoaderFunctionArgs } from 'react-router-dom';
import { Entity } from '../../backend/models/entity';
import { Technology } from '../../backend/models/technology';
import { msalInstance } from '..';

export type EditEntityLoaderResult = { entity: Entity; entities: Entity[]; technologies: Technology[] };

type PropType = {
  getEntities: () => Promise<Entity[]>;
  getTechnologies: (name: string) => Promise<Technology[]>;
};

const EditEntityLoader = async ({
  params,
  getEntities,
  getTechnologies,
}: LoaderFunctionArgs & PropType): Promise<EditEntityLoaderResult> => {
  const loggedIn = Boolean(msalInstance.getActiveAccount());
  if (!loggedIn) {
    return { entity: { name: '', order: 0, id: undefined }, entities: [], technologies: [] } as EditEntityLoaderResult;
  }
  const [entities, technologies] = await Promise.all([getEntities(), getTechnologies(params.name ?? '')]);
  return {
    entity: entities.find((e) => e.name.toLocaleLowerCase() === params.name?.toLocaleLowerCase()) as Entity,
    entities,
    technologies,
  };
};

export default EditEntityLoader;
